exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 767px) {\n.container[data-v-83153692] {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n}\n.resultPanel[data-v-83153692] {\n    position: fixed;\n    left: 10%;\n    top: 103px;\n    width: 80%;\n    padding: 20px;\n    background: white;\n    color: black;\n    z-index: 10000;\n    -webkit-box-shadow: 5px 5px 10px grey;\n            box-shadow: 5px 5px 10px grey;\n}\n}\n", ""]);

// exports
